// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qsj0C","title":"styles_title__27hQ2"};